import { Component } from '@angular/core';

@Component({
  selector: 'app-lvl2-test',
  templateUrl: './lvl2-test-page.component.html',
  styleUrls: ['./lvl2-test-page.component.scss']
})
export class Lvl2TestPageComponent {
}
